import "./css/intro.css";

function intro() {
	return (
		<div className="Intro">
			<div className="IntroContainer">
				<div className="IntroTitle">Tucker Whitaker</div>
				<div className="Summary">
					I create, optimize, and maintain compelling web experiences.
				</div>
				<div className="IntroCover"></div>
			</div>
		</div>
	);
}

export default intro;
